// extracted by mini-css-extract-plugin
export default {"loginform":"SignIn_loginform__gPMqY","boxasbtn":"SignIn_boxasbtn__KM9fH","hdcrd":"SignIn_hdcrd__MVxSt","txor":"SignIn_txor__cBEMb"};